import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, Container } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Flipped = styled.div`
  ${mediaQuery('tablet')} {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const OverviewContainer = styled(Container)`
  margin-top: 30px;
`;

export const FilterContainer = styled(Container)`
  margin-top: 30px;
`;

export const MobileFilterContainer = styled.form`
  flex-direction: column;
`;

export const ResetButton = styled(Button)``;

export const ApplyButton = styled(Button)``;

export const inputSelectStyle = css`
  min-width: 200px;
`;

export const SectionWrapperBreeders = styled.div`
  padding: 30px 0;
`;

export const SectionTitle = styled.div<{ color: 'blue' | 'light' }>`
  color: ${(props) => props.theme.color[props.color].default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  padding: 25px 0;
  ${responsiveFontSize(50)}
`;

export const VetAdviceWrapper = styled.div`
  padding: 15px 0;
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 600;
  display: inline-flex;
  align-items: center;

  ${mediaQuery('phone')} {
    flex-direction: column;
    text-align: center;
    width: 100%;
  }
`;
